module.exports = __webpack_public_path__ + "img/galileo_icon4.bfe10b87.png";